import { render, staticRenderFns } from "./DuplicateStudySet.vue?vue&type=template&id=6a67b158&scoped=true&"
import script from "./DuplicateStudySet.vue?vue&type=script&lang=js&"
export * from "./DuplicateStudySet.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateStudySet.vue?vue&type=style&index=0&id=6a67b158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a67b158",
  null
  
)

export default component.exports